import { render, staticRenderFns } from "./NewsFeedBox.vue?vue&type=template&id=3e2bf76c&scoped=true&"
import script from "./NewsFeedBox.vue?vue&type=script&lang=js&"
export * from "./NewsFeedBox.vue?vue&type=script&lang=js&"
import style0 from "./NewsFeedBox.vue?vue&type=style&index=0&id=3e2bf76c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2bf76c",
  null
  
)

export default component.exports